
const FooterPage =()=>{


    return(
        <div style={{position:'fixed',bottom:'0px',width:'100%'}}>
            <nav>

                <ul id="nav-mobile" className="right hide-on-med-and-down">

                    <li> <img src='./images.jpg' style={{ 'height': '50px' }}></img></li>

      
                </ul>
            </nav>
        </div>
    )

}


export default FooterPage